import { css } from '@emotion/core';
import { Chip, Tooltip } from '@material-ui/core';
import React from 'react';

interface SparkScoreProps {
    score: number;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const styles = css`
    background-color: white !important;
    color: black;

    &:hover {
        background-color: #efefef !important;
    }
`;

export const SparkScore: React.FC<SparkScoreProps> = ({ score, onClick }) => (
    <Tooltip title="Spark score (0–1)">
        <Chip label={score.toFixed(2)} variant="outlined" onClick={onClick} css={styles} />
    </Tooltip>
);
